export default __webpack_public_path__ + "static/media/TreePlantingHero.139fbef1.png";